'use client'

import { CSSVariablesResolver, Notification, createTheme, MantineTheme } from '@mantine/core'
import Button from './components/Button'
import ActionIcon from './components/ActionIcon'
import Alert from './components/Alert'
import Chip from './components/Chip'
import Autocomplete from './components/Autocomplete'
import TextInput from './components/TextInput'
import NumberInput from './components/NumberInput'
import Textarea from './components/Textarea'
import Divider from './components/Divider'
import Checkbox from './components/Checkbox'
import { tokens } from './styles/variables'
import './styles/variables.css'
import Badge from './components/Badge'
import Progress from './components/Progress'
import List from './components/List'
import Modal from './components/Modal'
import Radio from './components/Radio'
import Select from './components/Select'
import NativeSelect from './components/NativeSelect'
import MultiSelect from './components/MultiSelect'
import Card from './components/Card'
import Breadcrumbs from './components/Breadcrumbs'
import ThemeIcon from './components/ThemeIcon'
import SegmentedControl from './components/SegmentedControl'
import Pill from './components/Pill'
import Drawer from './components/Drawer'
import Text from './components/Text'
import { Roobert } from '../app/fonts'

const { colorPrimitives, headings } = tokens

const theme = createTheme({
    primaryColor: 'blue',
    cursorType: 'pointer',
    focusRing: 'auto',
    fontFamily: 'var(--gm-font-family)',
    colors: {
        alert: colorPrimitives.red,
        ...colorPrimitives,
    },

    fontSizes: {
        xs: 'var(--gm-text-xs-font-size)', // 12px
        sm: 'var(--gm-text-s-font-size)', // 14px
        md: 'var(--gm-text-m-font-size)', // 16px
        lg: 'var(--gm-text-l-font-size)', // 18px
        xl: 'var(--gm-text-xl-font-size)', // 20px
        '2xl': 'var(--gm-text-2xl-font-size)', // 24px
    },
    lineHeights: {
        xs: 'var(--gm-text-xs-line-height)',
        sm: 'var(--gm-text-s-line-height)',
        md: 'var(--gm-text-m-line-height)',
        lg: 'var(--gm-text-l-line-height)',
        xl: 'var(--gm-text-xl-line-height)',
    },
    spacing: {
        xs: 'var(--gm-spacing-10)',
        sm: 'var(--gm-spacing-12)',
        md: 'var(--gm-spacing-16)',
        lg: 'var(--gm-spacing-24)',
        xl: 'var(--gm-spacing-32)',
    },

    // component defaults
    components: {
        Title: {
            defaultProps: {
                c: 'gray.9',
            },
        },
        Text,
        Chip,
        Alert,
        Button,
        ActionIcon,
        Notification: Notification.extend({ defaultProps: { withBorder: true } }),
        Autocomplete,
        TextInput,
        NumberInput,
        Textarea,
        Badge,
        Progress,
        Divider,
        List,
        Modal,
        Checkbox,
        Radio,
        Select,
        NativeSelect,
        MultiSelect,
        Card,
        Breadcrumbs,
        ThemeIcon,
        SegmentedControl,
        Pill,
        Drawer,
    },
    headings: {
        ...headings,
    },
    other: {
        fontWeights: {
            bold: 'var(--gm-weight-text-bold)',
        },
        lineSpacing: {
            sm: 'var(--gm-display-sm-letter-spacing)',
        },
    },
})

export const rebrandCssResolver: CSSVariablesResolver = (theme: MantineTheme) => ({
    variables: {
        '--gm-font-family': `${Roobert.style.fontFamily}, sans-serif, -apple-system, system-ui, 'Apple Color Emoji', 'Segoe UI Emoji'`,
        '--mantine-shadow-xs': '0px 1px 1px 0px rgba(64, 63, 62, 0.05), 0px 2px 7px 0px rgba(64, 63, 62, 0.05)',
    },
    light: {
        '--mantine-color-text': theme.colors.gray[9],
        '--mantine-color-error': theme.colors.red[7],
        '--mantine-color-body': theme.colors.gray[0],
    },
    dark: {
        '--mantine-color-body': theme.colors.gray[0],
    },
})

export default theme
